import type { MailListItemContextMenuProps as MailListItemContextMenuV9Props } from "./components/MailListItemContextMenuV9";
import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, type LazyComponent, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "MailListItemContextMenu"*/ "./lazyIndex"), { name: "MailListItemContextMenu" });

export const MailListItemContextMenuV9: LazyComponent<MailListItemContextMenuV9Props, unknown, void> = createLazyComponent(lazyModule, m => m.MailListItemContextMenuV9);
